module.exports = __webpack_public_path__ + "img/home.faaca291.png";